import React from 'react';

import { Typography } from '@mui/material';

import { classes } from './styles';

interface SectionHeadingProps {
  id: string;
  children: React.ReactNode;
  fontFamily?: string;
  variant?: 'default' | 'helperText' | 'compact' | 'inline';
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({
  id,
  children,
  fontFamily,
  variant = 'default'
}) => (
  <Typography component="h2" id={id} sx={classes.sectionHeading.rootSx(fontFamily, variant)}>
    {children}
  </Typography>
);

export default SectionHeading;
